import * as OrderTexts from '../../../../../../../intl'
import { form } from '../../../../formState'

import { Props } from '../../typings'
import { OrderFormValues } from '../../../../typings'

import { createValidateTimeWindowExceptions } from './hooks/createValidateTimeWindowExceptions'

import { TimeWindowExceptionField } from './components/TimeWindowExceptionField'

export function TimeWindowExceptions(props: Props) {
  const { orderStepType, disabledFields = [], workingDayStartSec } = props

  const eligibility = form.useFormField('order.eligibility').field.value
  const recurrencePeriod = form.useFormField('recurrenceSettings.recurrencePeriod').field.value
  const recurrenceDate =
    recurrencePeriod.recurrenceType !== 'NO_REPEAT' ? recurrencePeriod.date : undefined

  const fieldName = `${orderStepType}.timeWindowExceptions` as
    | 'pickup.timeWindowExceptions'
    | 'delivery.timeWindowExceptions'

  form.useAddFieldValidation<typeof fieldName>(fieldName, (field, _formApi) => {
    const timeWindows = field.value
    if (timeWindows && Object.keys(timeWindows).length > 0) {
      const timeWindowExceptionsValidationMessage = createValidateTimeWindowExceptions(
        timeWindows,
        workingDayStartSec,
        eligibility,
        recurrenceDate,
      )

      return timeWindowExceptionsValidationMessage
    }
  })

  const disabledTWE: boolean = disabledFields.includes('timeWindowExceptions')

  return (
    <TimeWindowExceptionField<`${typeof orderStepType}.timeWindowExceptions`, OrderFormValues>
      name={`${orderStepType}.timeWindowExceptions`}
      timeWindowProps={{
        testId: 'timeWindowsExceptions',
        label: OrderTexts.getTimeWindowExceptionListText(),
        disabled: disabledTWE,
      }}
    />
  )
}
